<p-card class="mt-3">
    <app-table-component [data]="activitiesList()" [columns]="tableColumns" [totalRecords]="totalRecords()"
        [rows]="rows" [first]="first" (pageChange)="onPageChange($event)" [tableName]="''" [showSearch]="true"
        [searchControl]="searchControl" (searchChange)="onSearchChange()"
        [customFilters]="[carStatusFilter, commandStatusFilter, createdDateFilter]"
        [showClearFilters]="false"
        searchPlaceholder="Email, Command name..." [showColumnSelector]="false" [showHeaderBorder]="false" />
</p-card>